var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"contenteditable notranslate text-break",attrs:{"contenteditable":!_vm.disabled},on:{"input":_vm.update,"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }